import { useQuery } from "@tanstack/react-query"
import { Duration } from "luxon"

import MetricDisplay from "@/features/dashboards/components/MetricDisplay.tsx"

import { type MonthlyDisplayData } from "../types/monthlyDisplayTypes.ts"

export default function MonthlyDisplay({
  fetcher,
}: {
  fetcher: () => Promise<MonthlyDisplayData>
}) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["monthlyDisplay", { location: 3 }],
    queryFn: fetcher,
    refetchInterval: 10000,
  })

  return (
    <div className="rounded-md shadow-sm p-4 border col-span-4 md:col-span-1 h-[325px]">
      <h2 className="text-lg font-semibold">Monthly Totals</h2>
      <div className="flex flex-col gap-3 mt-3">
        <MetricDisplay
          label="Total Manure Trucked"
          value={data ? data.manure : 0}
          loading={isPending}
          error={isError}
          unit="Gallons"
        />
        <MetricDisplay
          label="Total UF Trucked"
          value={data ? data.uf : 0}
          loading={isPending}
          error={isError}
          unit="Gallons"
        />
        <MetricDisplay
          label="Total Loads"
          loading={isPending}
          error={isError}
          value={data ? data.loads : 0}
          unit="#"
        />
        <MetricDisplay
          label="Time per Load"
          loading={isPending}
          error={isError}
          value={data ? Duration.fromObject({ hours: data.timePerLoad }).toFormat("h:mm") : 0}
          unit="H:MM"
        />
      </div>
    </div>
  )
}
